import {
  IconAtom,
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLocation,
  IconMeter,
  IconPcLine,
  IconPlug,
  IconRoad,
  IconRoom,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTools,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';

import integrationVideo from '@src/assets/images/main/video/integration.mp4';

import image2 from '@src/assets/images/solution/medicalWaste/img/2.avif';
import image3 from '@src/assets/images/solution/medicalWaste/img/3.avif';
import image4 from '@src/assets/images/solution/medicalWaste/img/4.avif';
import image5 from '@src/assets/images/solution/medicalWaste/img/5.avif';
import image6 from '@src/assets/images/solution/medicalWaste/img/6.avif';
import image7 from '@src/assets/images/solution/medicalWaste/img/7.avif';
import image8 from '@src/assets/images/solution/medicalWaste/img/8.avif';
import image9 from '@src/assets/images/solution/medicalWaste/img/9.avif';

export default {
  type: '医疗解决方案',

  banner: {
    title: '通过基于机器人自动化系统提升医疗废弃物管理效率',
    desc: '结合机器人与 ORBRO 位置追踪系统，实时掌握医疗废弃物位置，提供自动化运营管理。',
  },

  video: {
    title: '体验结合机器人和位置追踪系统的智能医疗废弃物管理',
    desc: '通过机器人与 ORBRO 位置追踪系统的整合，实现精准位置监控与自动化管理，显著提高运营效率。',
    play: integrationVideo,
  },

  func: [
    {
      theme: '实时掌握机器人位置，高效管理医疗废弃物',
      title: '实时机器人位置追踪与运营监控',
      desc: '通过 ORBRO 位置追踪系统，精准掌握机器人位置与运营状态，提高医疗废弃物管理的准确性，实现即时响应并最大化运营效率。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image2,
    },
    {
      title: '基于自主导航的转运到装卸区',
      desc: '机器人利用自主导航技术安全前往装卸区，无需人工干预完成作业，提升运营效率并保障作业人员安全。',
      sub1: '指定风险资产',
      icon1: IconWarningGray,
      sub2: '设置响应方式',
      icon2: IconBellGray,
      image: image3,
    },
    {
      title: '与装载设备自动联动运行',
      desc: '构建装载设备与机器人之间的自动联动系统，顺畅管理机器人呼叫和装载准备状态，大幅提升作业效率和处理速度。',
      sub1: '高精度提供',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconChainLinkGray,
      image: image4,
    },
    {
      title: '智能储物柜联动',
      desc: '高效联动智能储物柜与系统，轻松进行数据访问和资产管理，提升操作便利性与准确性。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      theme: '实时掌握设备状态，自动化消毒管理',
      title: '作业状态实时监控',
      desc: '实时监控每台机器人的作业状态，遇到问题可即时响应，最大限度减少运营中可能发生的错误，打造安全的管理环境。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '同时管理多台机器人',
      desc: '在一个系统内同时管理多台机器人，提高管理效率，防止机器人之间作业重复和冲突，保障作业的准确性与顺畅性。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '与消毒系统联动与管理',
      desc: '轻松与等离子、UVC、HPV 等消毒设备联动，快速且精准地完成医疗废弃物和医疗器具的消毒工作，维持清洁卫生的环境。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image8,
    },
    {
      title: '实时查看设备作业状态',
      desc: '实时精准监控每台消毒设备的连接状态和作业进度，及时发现并处理运营过程中可能出现的问题。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据存储',
      icon2: IconCloudCheckGray,
      image: image9,
    },
  ],

  subfunc: {
    title: '主要功能概览',
    desc: '',

    data: [
      {
        icon: IconLocation,
        title: '实时追踪机器人位置',
        desc: '准确掌握机器人当前位置，实时监控运营状态。',
      },
      {
        icon: IconMeter,
        title: '作业状态实时监控',
        desc: '实时监测机器人作业进度，快速响应处理。',
      },
      {
        icon: IconUserCheck,
        title: '多台机器人同时管理',
        desc: '高效同时管理多台机器人，提高运营准确性。',
      },
      {
        icon: IconRoad,
        title: '自主导航转运到装卸区',
        desc: '机器人自主导航前往装卸区，提升作业效率和安全性。',
      },
      {
        icon: IconPlug,
        title: '与装载设备自动联动',
        desc: '自动管理机器人呼叫及装载准备状态，提高运营效率。',
      },
      {
        icon: IconPcLine,
        title: '机器人专用管理仪表盘',
        desc: '提供专用仪表盘，直观管理所有机器人运营状态和数据。',
      },
      {
        icon: IconRoom,
        title: '智能储物柜系统联动',
        desc: '与储物柜联动，高效管理医疗废弃物储存状态。',
      },
      {
        icon: IconTools,
        title: '消毒设备实时监控',
        desc: '实时监测各消毒设备连接与作业状态，保障稳定运行。',
      },
      {
        icon: IconAtom,
        title: '多种消毒系统联动',
        desc: '轻松连接等离子、UVC、HPV 消毒设备，支持快速全面的灭菌作业。',
      },
      {
        icon: IconChartBar,
        title: '实时综合运营管理',
        desc: '在单一界面上综合管理所有设备的运营状态与库存情况，支持快速决策。',
      },
    ],
  },

  system: {
    title: '系统结构',
    img: rtlsSystem,
  },

  productTitle: '产品组合',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'retailOffice',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
